import { render } from "./Main.vue?vue&type=template&id=8643fd42&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=8643fd42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8643fd42"

export default script